import { useSelector } from 'react-redux';
import { selectConfigState } from '../selectors/config.selector';
import { getLocale } from '../utils/local.utils';

interface LogoutRedirectParams {
    redirectUrl?: string;
    lang?: string;
}

export const useLogoutRedirect = () => {
    const configState = useSelector(selectConfigState);

    const redirectToLogout = (params?: LogoutRedirectParams) => {
        const lang = params?.lang || getLocale();
        const redirectUrl = params?.redirectUrl || window.location.href;

        const queryParams = new URLSearchParams({
            redirectUrl,
            lang
        });

        const logoutUrl = `${configState.globalBase}/id/logout?${queryParams.toString()}`;
        window.location.href = logoutUrl;
    };

    const generateLogoutUrl = (params?: LogoutRedirectParams) => {
        const lang = params?.lang || getLocale();
        const redirectUrl = params?.redirectUrl || window.location.href;

        const queryParams = new URLSearchParams({
            redirectUrl,
            lang
        });
        return `${configState.globalBase}/id/logout?${queryParams.toString()}`;
    };

    return {
        redirectToLogout,
        generateLogoutUrl
    };
};
